import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { enabledSelector } from 'selectors/testTarget/offers/carouselOnPLP/enabled/enabledSelector';

const showCarouselOnPLPSelector = createSelector(isTestTargetReadySelector, enabledSelector, (testReady, enabled) => ({
    enabled: testReady && enabled === true
}));

export { showCarouselOnPLPSelector };
